/* eslint-disable no-unused-vars */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const apiSlice = createApi({
  reducerPath: "api",
  tagTypes: ["User","Property","Localities","Projects","ItemCategory","Items","Blog","BlogAnalytics","user-property"], // Ensure
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BACKEND_HOST_URL}/api/v1`,
  }),
  endpoints: (builder) => ({}), // Initially, we'll keep this empty
});

export default apiSlice;